import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpSharedIconBubbles.scss';

import EmailIcon from 'dibs-icons/exports/Email';
import { PdpSharedSendToFriendModalLoader } from '../PdpSharedModals/PdpSharedSendToFriendModal/PdpSharedSendToFriendModalLoader';

// helpers
import { trackEmailClick } from '../tracking/iconBubblesTracking';
import get from 'lodash.get';

class PdpSharedIconBubbleEmailComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.onClick = this.onClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.setState({ modalOpen: false });
    }

    onClick() {
        this.setState({ modalOpen: true }, () => {
            // fire tracking
            trackEmailClick(this.props.item.serviceId);
        });
    }

    render() {
        const { item, skuId, user, viewer } = this.props;
        const { isPdpStfEnabled } = viewer || {};

        if (!isPdpStfEnabled) {
            return null;
        }
        let imageSrc = item.firstPhotoWebPath;
        if (skuId) {
            const sku = (item.skus || []).find(s => s.serviceId === skuId);
            const skuPhoto = get(sku, 'firstPhotoWebPath');
            imageSrc = skuPhoto ? skuPhoto : imageSrc;
        }

        const senderEmail = get(user, 'profile.email') || '';
        const { modalOpen } = this.state;
        const selectedItem = {
            itemId: get(item, 'serviceId') || '',
            title: get(item, 'title') || '',
            src: imageSrc,
        };

        return (
            <div className={styles.bubble} onClick={this.onClick}>
                <EmailIcon className={styles.icon} />
                <PdpSharedSendToFriendModalLoader
                    type="PDP"
                    modalOpen={modalOpen}
                    relay={this.props.relay}
                    senderEmail={senderEmail}
                    selectedItems={[selectedItem]}
                    skuId={skuId}
                    closeModal={this.closeModal}
                />
            </div>
        );
    }
}

PdpSharedIconBubbleEmailComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    skuId: PropTypes.string,
};

export const PdpSharedIconBubbleEmail = createFragmentContainer(PdpSharedIconBubbleEmailComponent, {
    viewer: graphql`
        fragment PdpSharedIconBubbleEmail_viewer on Viewer {
            ... @include(if: $fetchPdp) {
                isPdpStfEnabled: isEnabled(key: "enablePdpStf")
            }
        }
    `,
    item: graphql`
        fragment PdpSharedIconBubbleEmail_item on Item {
            serviceId
            title
            firstPhotoWebPath(size: small)
            skus {
                serviceId
                firstPhotoWebPath(size: small)
            }
        }
    `,
    user: graphql`
        fragment PdpSharedIconBubbleEmail_user on User {
            profile {
                email
            }
        }
    `,
});
